<ng-container *ngIf="splashWithConfig$ | async as splash">
    <floori-splash *ngIf="splash.visible" [logoUrl]="splash.logoUrl!" [flooriIoLinkEnable]="splash.flooriIoLinkEnable"></floori-splash>
</ng-container>

<main>
    <router-outlet></router-outlet>
</main>
<input type="text" [value]="url" id="floori-url" />
